import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import TopNav from "../components/TopNav";
import ListingGenerator from "../components/listing/ListingGenerator";
import MyProjects from "../components/MyProjects";
import { useAuth } from "../contexts/AuthContext";
import { Plus, Sparkles, Library, FileText } from "lucide-react";

const Tabs = ["listing", "projects"];

const Dashboard = () => {
  const { profile } = useAuth();
  const navigate = useNavigate();
  const [params, setParams] = useSearchParams();
  const initial = params.get("tab") || "listing";
  const [tab, setTab] = useState(Tabs.includes(initial) ? initial : "listing");

  useEffect(() => {
    setParams({ tab }, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab]);

  return (
    <div className="min-h-screen bg-[#FAFAF9]">
      <TopNav />

      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-10 pb-6">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
          <div>
            <h1
              className="text-3xl tracking-tight text-[#2C2C2A]"
              style={{ fontFamily: "Outfit, Inter, sans-serif", fontWeight: 500 }}
            >
              Welcome{profile?.full_name ? `, ${profile.full_name.split(" ")[0]}` : "" }
            </h1>
            <p className="text-sm text-[#5F5E5A] mt-1">
              Generate a listing or start a new cover project.
            </p>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={() => navigate("/frontmatter")}
              data-testid="new-frontmatter-btn"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-[8px] border border-[#D3D1C7] text-[#2C2C2A] text-sm font-medium hover:bg-[#F1EFE8] transition-colors"
            >
              <FileText className="w-4 h-4" /> Front matter
            </button>
            <button
              onClick={() => navigate("/cover/new")}
              data-testid="new-cover-btn"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-[8px] bg-[#534AB7] text-white text-sm font-medium hover:bg-[#3C3489] transition-colors shadow-sm"
            >
              <Plus className="w-4 h-4" /> New cover project
            </button>
          </div>
        </div>

        <div className="mt-8 border-b border-[#D3D1C7]">
          <div className="flex items-center gap-1">
            {[
              { id: "listing", label: "Listing Generator", icon: Sparkles },
              { id: "projects", label: "My Projects", icon: Library },
            ].map(({ id, label, icon: Icon }) => (
              <button
                key={id}
                onClick={() => setTab(id)}
                data-testid={`tab-${id}`}
                className={`relative px-4 py-3 text-sm font-medium transition-colors flex items-center gap-2 -mb-[0.5px] ${
                  tab === id ? "text-[#534AB7]" : "text-[#5F5E5A] hover:text-[#2C2C2A]"
                }`}
              >
                <Icon className="w-4 h-4" strokeWidth={1.5} />
                {label}
                {tab === id && <span className="absolute left-0 right-0 -bottom-px h-[2px] bg-[#534AB7]" />}
              </button>
            ))}
          </div>
        </div>
      </div>

      <main className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-24">
        {tab === "listing" && <ListingGenerator />}
        {tab === "projects" && <MyProjects />}
      </main>
    </div>
  );
};

export default Dashboard;
